module.exports = __webpack_public_path__ + "static/media/logo.2117e3ba.PNG";